{
  "loanWidget": {
    "preliminaryLoanAmountHeading": "See the company's credit limit",
    "privacyPolicyConsent": "You need to approve that {{company}} processes your <1>personal data</1> to see your loan options",
    "estimateLimitWithoutCreditCheck": "See credit limit - without credit check",
    "estimateLimit": "Estimate your credit limit",
    "loadingText": "Estimating your borrowing capacity and likelihood of receiving offers…",
    "makeAnotherEstimate": "Make another estimate",
    "yourEstimatedCreditLimit": "Your estimated credit limit",
    "immediateResponse": "Immediate response",
    "immediateResponseWithoutCreditCheck": "Immediate response, without credit check",
    "trustTagFreeOfCharge": "Free of charge",
    "trustTagOffersWithin24h": "Offers within 24 hours",
    "trustTagLenders": "30+ lenders",
    "whatHappensNextTitle": "What happens next?",
    "whatHappensNextStep1": "Complete the application — takes only a few minutes",
    "whatHappensNextStep2": "Receive offers from lenders within 24 hours",
    "whatHappensNextStep3": "Compare and choose the best offer",
    "trustTagsListLabel": "Before you submit",
    "veryHighLikelihood": "Very high likelihood of getting offers",
    "highLikelihood": "High likelihood of getting offers",
    "possibleLikelihood": "Getting offers is possible",
    "estimatedRange": "Estimated range",
    "advisoryResultTitle": "We could not estimate your credit limit and likelihood automatically",
    "advisoryResultDescription": "Our automatic estimate is available for amounts up to {{amount}}. For higher amounts, our advisory service provides personalized guidance.",
    "advisoryMeetingPrompt": "Book an advisory meeting to discuss your options!",
    "whatIsAdvisoryService": "What is the advisory service?",
    "advisoryServiceDescription1": "We offer a specialized advisory service aimed at helping small and medium-sized enterprises (SMEs) secure optimal financing at a lower interest rate. The service is particularly useful for businesses seeking financing between {{amountLow}} and {{amountHigh}}.",
    "advisoryServiceDescription2": "Our advisors support you with a more extensive business case, including a clear description of your business to enable lenders to better understand your potential and thereby offer better terms.",
    "advisoryServiceDescription3": "You will have access to your personal advisor throughout the whole process. Feel free to set up time for an initial meeting.",
    "continueNowToGetRealOffers": "Continue now to get offers",
    "howItWorksDescription1": "Only <strong>one application and credit check</strong>",
    "howItWorksDescription2": "<strong>Best rate guarantee:</strong> We let 30+ lenders compete for your application",
    "howItWorksDescription3": "<strong>Time efficient:</strong> Get offers within 24 hours",
    "largerAmountsPossible": "Higher amounts are possible with leasing, factoring or if you are applying for a real estate loan",
    "howCanYouImproveYourChances": "How can you improve your chances of getting the full desired amount?",
    "improveYourChancesTitle": "Maximise your loan amount",
    "improveYourChancesIntro": "You can normally borrow 10–20% of your turnover. Has your turnover recently increased? Make sure to highlight this in your application — it can make a big difference.",
    "improveYourChancesLargerAmounts": "Larger loan amounts may be possible in some cases:",
    "improveYourChancesBullet1Question": "Buying equipment?",
    "improveYourChancesBullet1Text": "Use it as collateral or finance via leasing to unlock a higher amount.",
    "improveYourChancesBullet2Question": "Can you offer additional collateral?",
    "improveYourChancesBullet2Text": "Property mortgages or corporate charges can give you up to 60–80% of their value.",
    "improveYourChancesBullet3Question": "Part of a group?",
    "improveYourChancesBullet3Text": "Loan options via the parent company can open new possibilities.",
    "improveYourChancesReasonableAmount": "Also remember to apply for a reasonable amount — overly high amounts can lead to rejection.",
    "improveYourChancesContactUs": "We'll help you find the right solution. Start an application or <contactLink>contact us</contactLink> directly and we'll figure it out together.",
    "howWeEstimatedDescription1": "The estimate is based on previous offers that customers similar to your company have received. We collect public data about your company to estimate your credit limit.",
    "howWeEstimatedDescription2": "You may receive a higher or lower amount in reality.",
    "howWeEstimatedDescription3": "The only way to find out what your company can actually get is to make an application.",
    "bookAMeeting": "Book a free meeting",
    "continueToApplication": "Continue to application",
    "expandCalculatorForm": "Show more",
    "collapseCalculatorForm": "Show less"
  },
  "foretagarnaContent": {
    "title": "Member benefit",
    "resultMemberBenefitText": "You will receive <compensation>{{compensation}}</compensation> in compensation if you sign new financing via Krea for <amount>{{amount}}</amount>."
  },
  "applicationForm": {
    "commons": {
      "requestedAmountPreLabel": "Desired financing",
      "exactRequestedAmountPlaceholder": "1 000 000",
      "emailErrors": {
        "validationError": "Please enter a valid e-mail address"
      }
    }
  }
}
